import React, { ChangeEvent } from 'react';
import { CheckboxInput } from 'lib/components';
import { Flex } from 'lib/components/styles/layout';
import {
  CheckboxLabel,
  ParagraphSmall500,
} from 'lib/components/styles/typography';
import { Textarea } from 'lib/components/folders/style';
import { useTheme } from 'styled-components/macro';
type Props = {
  message?: string;
  notify?: boolean;
  values?: { message: string; notify: boolean };
  setFieldValue?: (field: string, value: any) => void;
  setNotify?: (value: boolean) => void;
  handleTextChange?: (e: ChangeEvent<HTMLInputElement>) => void;
};

export const MessageAndNotification = ({
  message,
  notify,
  handleTextChange,
  setNotify,
  values,
  setFieldValue,
}: Props) => {
  const themes = useTheme();
  const forOem = !!setFieldValue && values;
  return (
    <Flex
      justifyContent='space-between'
      alignItems='center'
      width='100%'
      gap='12px'
      margin='13px 0 20px 0'
    >
      <Flex width='798px' gap='8px'>
        <ParagraphSmall500 color={themes.colors.neutral[80]}>
          Add Message (optional)
        </ParagraphSmall500>
        <Textarea
          height='116px'
          value={!!forOem ? values.message : message}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            if (setFieldValue) {
              setFieldValue('message', e.target.value);
            } else {
              handleTextChange?.(e);
            }
          }}
        />
      </Flex>
      <Flex flexDirection='row' gap='10px' alignItems='center'>
        <CheckboxInput
          id='check-notify-on-view'
          width='24px'
          blueCheck={true}
          checked={!!forOem ? values.notify : notify}
          onChange={(e: React.SyntheticEvent) => {
            const { checked } = e.target as HTMLInputElement;
            if (!!forOem) {
              setFieldValue('notify', checked);
            } else {
              setNotify?.(checked);
            }
          }}
        />
        <CheckboxLabel htmlFor='check-notify-on-view'>
          Notify users with access to this folder of these changes
        </CheckboxLabel>
      </Flex>
    </Flex>
  );
};
